export function ContainsSpecialChars(str: string) {
    const specialChars = new RegExp(/[`!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/?~]/);
    return specialChars.test(str);
}

export function ContainsAt(str: string) {
    const specialChars = new RegExp(/@/);
    return specialChars.test(str);
}

export function ContainsUpperCase(str: string) {
    const regex = new RegExp(/[A-Z]/);
    return regex.test(str);
}

export function truncateTitle(text: string, maxLength: number): string {
    if (text.length <= maxLength) return text;
    return text.slice(0, maxLength).trim() + "...";
};

export function capitalizeFirst(str?: string | null) {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
}
